var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"ticket-card",attrs:{"src":require("assets/ticket2.png")}})
}
var staticRenderFns = []

export { render, staticRenderFns }